const BankInfo = () => import('@/views/BankInfo')

export default [
  {
    path: '/bankInfo',
    component: BankInfo,
    meta: { requireAuth: true }
  }
]
